import React from 'react';
import NotFound from '../../NotFound';
import TaskSearchItem from '../TaskSearchItem';
import TaskSearchItemSkeleton from '../TaskSearchItemSkeleton';
import useInfiniteScroll from '../../../hooks/useInfiniteScroll';

const TasksFlatGridView = ({
  tasks,
  hasMore,
  loadingMore,
  onLoadMore,
  onTaskDelete,
  onEditClick,
  onStatusUpdate,
  highlightedTaskId,
  showDescription = false
}) => {
  const { scrollContainerRef } = useInfiniteScroll({
    onLoadMore,
    hasMore,
    loadingMore,
    items: tasks
  });

  if (!tasks?.length) {
    return <NotFound text="No tasks found" />;
  }

  return (
    <div
      ref={scrollContainerRef}
      className="scrollbar-thin mt-3"
      style={{ height: 'calc(100vh - 300px)', overflowY: 'auto', overflowX: 'hidden' }}
    >
      <div className="row">
        {tasks.map(task => (
          <div key={task?._id} className="col-12 col-md-6 mb-2 d-flex">
            <TaskSearchItem
              task={task}
              onTaskDelete={onTaskDelete}
              onEditClick={onEditClick}
              onStatusUpdate={onStatusUpdate}
              isHighlighted={highlightedTaskId === task._id}
              showDescription={showDescription}
            />
          </div>
        ))}
      </div>
      {loadingMore && (
        <div className="row mt-2" role="status" aria-busy="true" aria-label="Loading more tasks">
          {[0, 1].map(i => (
            <div key={i} className="col-12 col-md-6 mb-2 d-flex">
              <TaskSearchItemSkeleton />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TasksFlatGridView;
